module.exports = __webpack_public_path__ + "static/media/logo_loft.16de5b84.png";